/**
 * Utility functions for landing page analytics (2026.cashflosummit.in)
 */

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

/**
 * Get landing page analytics data from server
 */
export const getLandingPageAnalytics = async () => {
  try {
    const response = await fetch(`${API_BASE}/register/landing-page-analytics`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch landing page analytics');
    }

    const result = await response.json();
    
    if (!result.ok) {
      throw new Error(result.error || 'Failed to get landing page analytics');
    }

    return result.data || {};
  } catch (error) {
    console.error('Error fetching landing page analytics:', error);
    throw error;
  }
};

